<script setup lang="ts">
defineProps<{
  modelValue: string
  required?: boolean
}>()

defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<template>
  <input
    type="datetime-local"
    class="datetime-input"
    :value="modelValue"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    :required="required"
  />
</template>

<style scoped>
.datetime-input {
  width: 100%;
  box-sizing: border-box;
  background: var(--bg);
  border: 1px solid var(--line);
  color: var(--text);
  padding: 0.45rem 0.6rem;
  padding-right: 0.35rem;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color-scheme: dark;
  accent-color: var(--brand);
}

.datetime-input::-webkit-calendar-picker-indicator {
  filter: invert(0.7);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.datetime-input::-webkit-calendar-picker-indicator:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.datetime-input:focus {
  border-color: var(--brand2);
  outline: none;
  box-shadow: 0 0 0 3px rgba(42, 167, 255, 0.1);
}
</style>
